import request from '@/utils/request'

const uri = ''

export function Login(data) {
  return request({
    url: uri + 'auth/login',
    method: 'post',
    data
  })
}
// 注册用户
export function registUser(data) {
  return request({
    // url: 'sys/user/permissions',
    url: '/auth/regist',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}
// 切换身份
export function identitySelected(data) {
  return request({
    // url: 'sys/user/permissions',
    url: '/auth/identity/selected',
    method: 'post',
    data
  })
}
// 获取动态路由
export function getPermission() {
  return request({
    // url: 'sys/user/permissions',
    url: '/sys/auth/permissions',
    method: 'get'
  })
}
// 获取用户信息
export function getUserInfo() {
  return request({
    // url: 'sys/user/info',
    url: '/sys/auth/info',
    method: 'get'
  })
}
// -----------------------------------------------
// 上传图片
export function uploadPic() {
  return request({
    url: 'file/accessInfo',
    method: 'get'
  })
}
// 上传私有图片
export function privateUploadPic() {
  return request({
    url: 'file/private/accessInfo',
    method: 'get'
  })
}

// 发送验证码
export function sendValidCode(data) {
  return request({
    url: 'auth/regist/sendValidCode',
    method: 'get',
    data
  })
}

// 钉钉登录
export function ddLogin(data) {
  return request({
    url: 'sys/auth/login',
    method: 'post',
    data
  })
}

// 机构报名端获取用户信息
export function getAuthUserInfo() {
  return request({
    url: '/auth/info',
    method: 'get',
    type: 'user'
  })
}
// 获取选项options
export function getOptions(data) {
  return request({
    url: uri + 'sys/options',
    method: 'get',
    data
  })
}
// 修改密码
export function changepassword(data) {
  return request({
    url: uri + 'quchucai/user/pwd',
    method: 'put',
    data
  })
}
// 切换身份
export function getUserRole(data) {
  return request({
    url: 'sys/user/role/selected',
    method: 'post',
    data
  })
}
// 切换部门
export function getUserDepart(data) {
  return request({
    url: 'sys/user/depart/selected',
    method: 'post',
    data
  })
}
// 获取所有协会
export function getDepartList(data) {
  return request({
    url: uri + 'sys/user/depart/list',
    method: 'get',
    data
  })
}
// 切换机构/角色 quchucai/user/role/selected
export function userRoleSelected(data) {
  return request({
    url: 'quchucai/user/role/selected',
    method: 'post',
    data
  })
}
